import * as React from 'react';

import {RandomWildConfigurationContext, frameworkRandomWild} from './randomwildconfiguration';

const withRandomWildConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <RandomWildConfigurationContext.Consumer>
            {(auth: any): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...frameworkRandomWild}/>
                );
            }}
        </RandomWildConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withRandomWildConfiguration;